export type EditorResourceType = 'character' | 'location' | 'prop' | 'footage';

export type EditorMode =
  | 'storyboard-image'
  | 'storyboard-video'
  | 'character-image'
  | 'location-image'
  | 'prop-image'
  | 'dialogue-edit'
  | 'voice-generation'
  | 'sound-effect';

export type AssetType = 'image' | 'video';

export interface EditorContext {
  mode: EditorMode;
  projectId: string | null;
  storyboardId: string | null;
  resourceId: string | null;
  resourceType: EditorResourceType | null;
  tagId: string | null;
  previewItemId: string | null;
  dialogueId: string | null;
  videoId: string | null;
  /**
   * 自任务列表跳转且视频轨为占位、需从多条分镜生视频中精确选中时使用（服务端 jobId，与 generationStore.tasks[].jobId 一致）
   */
  targetVideoJobId: string | null;
  activeAssetType: AssetType;
  /**
   * 区分资源来自底部分镜资产 chip、资产库直接选择或分镜轨道，供编辑器选中态同步。
   */
  resourceSelectionSource: 'storyboard_binding' | 'resource_library' | 'storyboard_track' | null;
  resourceSelectionStoryboardId: string | null;
  resourceSelectionBoardId: string | null;
  resourceSelectionResourceName: string | null;
  resourceSelectionTagLabel: string | null;
}

export const DEFAULT_EDITOR_CONTEXT: EditorContext = {
  mode: 'storyboard-image',
  projectId: null,
  storyboardId: null,
  resourceId: null,
  resourceType: null,
  tagId: null,
  previewItemId: null,
  dialogueId: null,
  videoId: null,
  targetVideoJobId: null,
  activeAssetType: 'image',
  resourceSelectionSource: null,
  resourceSelectionStoryboardId: null,
  resourceSelectionBoardId: null,
  resourceSelectionResourceName: null,
  resourceSelectionTagLabel: null,
};
